// pages/Dashboard/Dashboard.js
import React, { useEffect } from "react";
import ChatbotScripts from './ChatbotScripts';
import UsedTokensChart from "./UsedTokenByDate";
import StatsBox from "./StatsBox";
import ChatbotStatsTable from "./StatsTable";
import { useChatbots } from "../../contexts/ChatbotContext";
import { Box, CircularProgress, Typography } from '@mui/material';

export default function Dashboard() {
   const { activeChatbot, isLoading: isChatbotLoading } = useChatbots();

    useEffect(() => {
        document.title = 'Dashboard | KlonIT Web Application';
    }, []);

    if (isChatbotLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
                <CircularProgress />
                <Typography sx={{ml: 2}}>Loading chatbots...</Typography>
            </Box>
        );
    }
    
    if (!activeChatbot) {
         return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
                <Typography>No chatbot selected. Please create or select a chatbot.</Typography>
            </Box>
        );
    }

   return (
      <div>
         <main className="content">
            <div className="container-fluid p-0">
               <div className="row mb-2 mb-xl-3 align-items-center">
                  <div className="col-auto">
                     <h3><strong>Dashboard for {activeChatbot.chatbot_name}</strong> </h3>
                  </div>
               </div>

               {/* These components now get their data from the updated useChatbotStats hook internally */}
               <StatsBox />
               
               <div className="row mt-4">
                  <div className="col-lg-6 mb-3 mb-lg-0">
                     <ChatbotScripts />
                  </div>
                  <div className="col-lg-6">
                     <ChatbotStatsTable/>
                  </div>
               </div>

               <UsedTokensChart />
            </div>
         </main>
      </div>
   );
}